import {
  DEFAULT_QUERY_PARAMS,
  QUERY_BUILDER_STAT_META,
  QUERY_TYPES,
  RECOMMENDED_FILTERS,
  BIO_FILTER_FIELDS,
} from "../utils/queryBuilder";
import {
  QUERY_PRESETS,
  FEATURED_QUERY_PRESETS,
} from "../utils/queryBuilderPresets";

const MLB_HITTING_STATS = Object.keys(QUERY_BUILDER_STAT_META);

export const mlbCatalog = {
  sport: "mlb",
  heroSubtitle: "Browse MLB careers and seasons with visual filters and shareable URLs.",
  queryTypes: QUERY_TYPES,
  groups: [],
  defaultGroupId: "hitting",
  yearMin: 1876,
  yearMax: 2025,
  nameSortField: "bioData.birthName",
  getPlayerPath: (id) => `/app/player/${id}`,
  fieldsByGroup: {
    hitting: MLB_HITTING_STATS,
  },
  fieldMeta: {},
  landingByGroup: {
    hitting: DEFAULT_QUERY_PARAMS,
  },
  recommendedByGroup: {
    hitting: RECOMMENDED_FILTERS,
  },
  presets: QUERY_PRESETS,
  featuredPresets: FEATURED_QUERY_PRESETS,
  bioFields: BIO_FILTER_FIELDS,
  teams: null,
};
